import { NavigationSliderSecondaryProps } from 'component/NavigationSliderSecondary/NavigationSliderSecondary.types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'
import NavigationSliderRenderer, {
  NavigationSliderProps,
  OptionProps
} from '../NavigationSlider'
import BrazilFlagSrc from './assets/brasil-flag.png'
import ChileFlagSrc from './assets/chile-flag.png'
import useContextualNavigationSlider from './hooks/useContextualNavigationSlider'

type ContextualNavigationSliderProps = {
  props: Partial<NavigationSliderProps> & {
    options: OptionProps[]
    brazilOnly?: boolean
    styleMap?: StyleMap
    justifyContent?: NavigationSliderSecondaryProps['justifyContent']
  }
}

const ContextualNavigationSlider = ({
  props
}: ContextualNavigationSliderProps) => {
  const { options, brazilOnly = false } = props

  const { t } = useTranslation()

  const defaultOptions = useMemo(() => {
    const options = [
      {
        value: 'brasil',
        label: t('countries-names.brasil'),
        Adornment: (
          <img
            src={BrazilFlagSrc}
            alt={t('filterable-map.countries-flags-alt.brasil')}
          />
        ),
        color: '#303032'
      },
      {
        value: 'chile',
        label: t('countries-names.chile'),
        Adornment: (
          <img
            src={ChileFlagSrc}
            alt={t('filterable-map.countries-flags-alt.chile')}
          />
        ),
        color: '#303032'
      }
    ]

    return brazilOnly ? [options[0]] : options
  }, [t, brazilOnly])

  const {
    options: formattedOptions,
    currentIndex,
    onNextClick,
    onPrevClick,
    disabledArrow
  } = useContextualNavigationSlider({
    options: options || defaultOptions,
    contextAttribute: 'country'
  })

  return (
    <NavigationSliderRenderer
      {...props}
      onNextClick={onNextClick}
      onPrevClick={onPrevClick}
      currentIndex={currentIndex}
      options={formattedOptions}
      disabledArrow={disabledArrow}
      disabled={formattedOptions.length === 1}
    />
  )
}

export default ContextualNavigationSlider
